import {
  Button,
  Card,
  CardActions,
  CardContent,
  CardMedia,
  Grid,
  makeStyles,
  Typography,
} from "@material-ui/core";
import React from "react";
import { GamesListType } from "../../Constants/Data";
import Apple from "../../Images/apple.png";
import Google from "../../Images/google.png";

type GameCardProps = {
  gameInfo: GamesListType;
};

const useStyles = makeStyles({
  Card: {
    display: "flex",
    height: "100%",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: 4,
  },
  Grid: {
    textAlign: "center",
    width: "100%",
  },
  Button: {
    width: "100%",
    transition: "0.2s all ease-in-out",
    "&:hover": {
      transform: "scale(1.1)",
    },
  },
  Image: {
    borderRadius: 10,
    objectFit: "contain",
  },
});

const GameCardView: React.FC<GameCardProps> = ({ gameInfo }) => {
  const classes = useStyles();
  return (
    <Card className={classes.Card}>
      <CardMedia
        component="img"
        alt="Contemplative Reptile"
        image={gameInfo.image}
        title={gameInfo.title}
        className={classes.Image}
      />
      <CardContent>
        <Typography align={"center"} gutterBottom variant="h5" component="h2">
          {gameInfo.title}
        </Typography>
      </CardContent>
      <CardActions>
        <Grid container spacing={1}>
          <Grid item xs={6} className={classes.Grid}>
            <Button
              size="small"
              color="primary"
              className={classes.Button}
              onClick={() => window.open(gameInfo.appleUrl, "_blank")}
            >
              <img src={Apple} alt={""} className={"width-100per"} />
            </Button>
          </Grid>
          <Grid item xs={6} className={classes.Grid}>
            <Button
              size="small"
              color="primary"
              className={classes.Button}
              onClick={() => window.open(gameInfo.googleStoreUrl, "_blank")}
            >
              <img src={Google} alt={""} className={"width-100per"} />
            </Button>
          </Grid>
        </Grid>
      </CardActions>
    </Card>
  );
};

export default GameCardView;
